import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--edit-specialism-modal',
    ];

    openModal(event) {
        event.preventDefault();

        this.profileEditSpecialismModalOutlet.openModal();
    }
}
